import React from 'react'
import { latLng, Polygon, Circle } from '@fareye/ui'
import { TripPoiProps } from '../../utility/types'
import { poiTypeLoadingAltLoading } from '@fareye/configs'
export function TripPoiMarker({
  poiNickName,
  radius,
  latitude,
  longitude,
  poiType,
  poiBounds
}: TripPoiProps) {
  const center = latLng(latitude, longitude)

  const poiColor = React.useMemo(() => {
    if (poiType === 'loading' || poiType === 'altloading') {
      return poiTypeLoadingAltLoading
    }
    return '#f50057'
  }, [poiType])

  return poiBounds ? (
    <>
      <Polygon
        color={poiColor}
        positions={JSON.parse(poiBounds).geometry.coordinates}
      />
      {/* {center ? (
        <Circle
          key={`poi_${poiNickName}`}
          radius={radius * 1000}
          center={center}
          color={poiType === 'loading' ? '#12de12' : '#f50057'}
        />
      ) : null} */}
    </>
  ) : center ? (
    <Circle
      key={`poi_${poiNickName}`}
      radius={radius * 1000}
      center={center}
      color={poiColor}
    />
  ) : null
}
